/**
 * Default values of parameters for pagination and sorting of resource lists
 *
 * @namespace tmrDefaultPagingParams
 * @type {ngConstant}
 */
export const constant = [
  'tmrDefaultPagingParams',
  {
    offset: 0,
    limit: 25,
    orderBy: 'CREATION_DATE',
    asc: false,
  },
]
